<template>
	<div class="main flex_center">
		<div class="leftImg">
			<img src="@/assets/404_images/404.png" alt="" />
		</div>
		<div class="rightBox">
			<div class="right404Txt">404错误!</div>
			<div class="error__headline"> 找不到网页！ </div>
			<div class="error__info"> 对不起，您正在寻找的页面不存在。尝试检查URL的错误，然后按浏览器上的刷新按钮或尝试在我们的应用程序中找到其他内容。 </div>
			<el-button type="primary" size="small" @click="goback">返回</el-button>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return {}
		},
		methods:{
			goback(){
				this.$router.go(-2);
			}
		}
	}
</script>

<style scoped>
	.main {
		align-items: center;
		height: 100vh;
	}

	.leftImg img {
		width: 600px;
		height: auto;
	}
	.rightBox{
		width: 300px;
	}
	.right404Txt {
		font-size: 32px;
		font-weight: bold;
		line-height: 40px;
		color: #1482f0;
		margin-bottom: 20px;
	}

	.error__headline {
		font-size: 20px;
		line-height: 24px;
		color: #222;
		font-weight: bold;
		margin-bottom: 10px;
	}

	.error__info {
		font-size: 13px;
		line-height: 21px;
		color: grey;
		margin-bottom: 30px;
	}
</style>